import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'

import translationAR from './locales/ar/translation.json'
import translationCS from './locales/cs/translation.json'
import translationDE from './locales/de/translation.json'
import translationEL from './locales/el/translation.json'
import translationEN from './locales/en/translation.json'
import translationES from './locales/es/translation.json'
import translationFA from './locales/fa/translation.json'
import translationFR from './locales/fr/translation.json'
import translationHA from './locales/ha/translation.json'
import translationHI from './locales/hi/translation.json'
import translationID from './locales/id/translation.json'
import translationIT from './locales/it/translation.json'
import translationJA from './locales/ja/translation.json'
import translationKO from './locales/ko/translation.json'
import translationNO from './locales/no/translation.json'
import translationPL from './locales/pl/translation.json'
import translationPT from './locales/pt/translation.json'
import translationRU from './locales/ru/translation.json'
import translationTA from './locales/ta/translation.json'
import translationTH from './locales/th/translation.json'
import translationTR from './locales/tr/translation.json'
import translationUR from './locales/ur/translation.json'
import translationVI from './locales/vi/translation.json'
import translationZH from './locales/zh/translation.json'

const resources = {
  ar: {
    translation: translationAR
  },
  cs: {
    translation: translationCS
  },
  de: {
    translation: translationDE
  },
  el: {
    translation: translationEL
  },
  en: {
    translation: translationEN
  },
  es: {
    translation: translationES
  },
  fa: {
    translation: translationFA
  },
  fr: {
    translation: translationFR
  },
  ha: {
    translation: translationHA
  },
  hi: {
    translation: translationHI
  },
  id: {
    translation: translationID
  },
  it: {
    translation: translationIT
  },
  ja: {
    translation: translationJA
  },
  ko: {
    translation: translationKO
  },
  no: {
    translation: translationNO
  },
  pl: {
    translation: translationPL
  },
  pt: {
    translation: translationPT
  },
  ru: {
    translation: translationRU
  },
  ta: {
    translation: translationTA
  },
  th: {
    translation: translationTH
  },
  tr: {
    translation: translationTR
  },
  ur: {
    translation: translationUR
  },
  vi: {
    translation: translationVI
  },
  zh: {
    translation: translationZH
  }
}

const supportedLngs = [
  'ar',
  'cs',
  'de',
  'el',
  'en',
  'es',
  'fa',
  'fr',
  'ha',
  'hi',
  'id',
  'it',
  'ja',
  'ko',
  'no',
  'pl',
  'pt',
  'ru',
  'ta',
  'th',
  'tr',
  'ur',
  'vi',
  'zh'
] as const

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    supportedLngs: [...supportedLngs],
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false, // react already safes from xss
      defaultVariables: {
        brand: 'OMDWallet',
        omdBrand: 'OneMillionDollars'
      }
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage']
    }
  })

export default i18n
